module.exports = __webpack_public_path__ + "static/media/mobileProgramsTile.7eabb866.svg";